// https://docs.cloud.google.com/text-to-speech/docs/list-voices-and-types

import { useConnectionStore } from '@/stores/connectionStore';
import { translateEnglishWords } from './translation';
import { navigateCircleOutline } from 'ionicons/icons';

// https://docs.cloud.google.com/text-to-speech/docs/chirp3-hd#use-chirp3-hd-voices

const mp3Voices = [
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Achernar", internal: "en-US-Chirp3-HD-Achernar"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Achird", internal: "en-US-Chirp3-HD-Achird"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Algenib", internal: "en-US-Chirp3-HD-Algenib"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Algieba", internal: "en-US-Chirp3-HD-Algieba"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Alnilam", internal: "en-US-Chirp3-HD-Alnilam"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Aoede", internal: "en-US-Chirp3-HD-Aoede"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Autonoe", internal: "en-US-Chirp3-HD-Autonoe"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Callirrhoe", internal: "en-US-Chirp3-HD-Callirrhoe"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Charon", internal: "en-US-Chirp3-HD-Charon"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Despina", internal: "en-US-Chirp3-HD-Despina"},

  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Enceladus", internal: "en-US-Chirp3-HD-Enceladus"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Erinome", internal: "en-US-Chirp3-HD-Erinome"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Fenrir", internal: "en-US-Chirp3-HD-Fenrir"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Gacrux", internal: "en-US-Chirp3-HD-Gacrux"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Iapetus", internal: "en-US-Chirp3-HD-Iapetus"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Kore", internal: "en-US-Chirp3-HD-Kore"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Laomedeia", internal: "en-US-Chirp3-HD-Laomedeia"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Leda", internal: "en-US-Chirp3-HD-Leda"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Orus", internal: "en-US-Chirp3-HD-Orus"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Puck", internal: "en-US-Chirp3-HD-Puck"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Pulcherrima", internal: "en-US-Chirp3-HD-Pulcherrima"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Rasalgethi", internal: "en-US-Chirp3-HD-Rasalgethi"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Sadachbia", internal: "en-US-Chirp3-HD-Sadachbia"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Sadaltager", internal: "en-US-Chirp3-HD-Sadaltager"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Schedar", internal: "en-US-Chirp3-HD-Schedar"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Sulafat", internal: "en-US-Chirp3-HD-Sulafat"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Umbriel", internal: "en-US-Chirp3-HD-Umbriel"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Vindemiatrix", internal: "en-US-Chirp3-HD-Vindemiatrix"},
  { vendor : "googleHD", lang: "en-US", gender: "f", display: "Zephyr", internal: "en-US-Chirp3-HD-Zephyr"},
  { vendor : "googleHD", lang: "en-US", gender: "m", display: "Zubenelgenubi", internal: "en-US-Chirp3-HD-Zubenelgenubi"},

  { vendor : "google", lang: "en-US", gender: "m", display: "Adam", internal: "en-US-Wavenet-A"},
  { vendor : "google", lang: "en-US", gender: "m", display: "Ben", internal: "en-US-Wavenet-B"},
  { vendor : "google", lang: "en-US", gender: "f", display: "Carol", internal: "en-US-Wavenet-C"},
  { vendor : "google", lang: "en-US", gender: "m", display: "David", internal: "en-US-Wavenet-D"},
  { vendor : "google", lang: "en-US", gender: "f", display: "Edith", internal: "en-US-Wavenet-E"},
  { vendor : "google", lang: "en-US", gender: "f", display: "Felicity", internal: "en-US-Wavenet-F"},
  { vendor : "google", lang: "en-US", gender: "f", display: "Gina", internal: "en-US-Wavenet-G"},
  { vendor : "google", lang: "en-US", gender: "f", display: "Heidi", internal: "en-US-Wavenet-H"},
  { vendor : "google", lang: "en-US", gender: "m", display: "Ike", internal: "en-US-Wavenet-I"},
  { vendor : "google", lang: "en-US", gender: "m", display: "Jason", internal: "en-US-Wavenet-J"},

  { vendor : "google", lang: "en-AU", gender: "f", display: "Alice", internal: "en-AU-Wavenet-A"},
  { vendor : "google", lang: "en-AU", gender: "m", display: "Bruce", internal: "en-AU-Wavenet-B"},
  { vendor : "google", lang: "en-AU", gender: "f", display: "Charlotte", internal: "en-AU-Wavenet-C"},
  { vendor : "google", lang: "en-AU", gender: "m", display: "Daniel", internal: "en-AU-Wavenet-D"},

  { vendor : "google", lang: "en-IN", gender: "f", display: "Amani", internal: "en-IN-Wavenet-A"},
  { vendor : "google", lang: "en-IN", gender: "m", display: "Baasim", internal: "en-IN-Wavenet-B"},
  { vendor : "google", lang: "en-IN", gender: "m", display: "Chirag", internal: "en-IN-Wavenet-C"},
  { vendor : "google", lang: "en-IN", gender: "f", display: "Divya", internal: "en-IN-Wavenet-D"},
  { vendor : "google", lang: "en-IN", gender: "f", display: "Edha", internal: "en-IN-Wavenet-E"},
  { vendor : "google", lang: "en-IN", gender: "m", display: "Fadi", internal: "en-IN-Wavenet-F"},

  { vendor : "google", lang: "en-GB", gender: "f", display: "Abigail", internal: "en-GB-Wavenet-A"},
  { vendor : "google", lang: "en-GB", gender: "m", display: "Barnaby", internal: "en-GB-Wavenet-B"},
  { vendor : "google", lang: "en-GB", gender: "f", display: "Candice", internal: "en-GB-Wavenet-C"},
  { vendor : "google", lang: "en-GB", gender: "m", display: "Dabney", internal: "en-GB-Wavenet-D"},
  { vendor : "google", lang: "en-GB", gender: "f", display: "Freya", internal: "en-GB-Wavenet-F"},
  { vendor : "google", lang: "en-GB", gender: "f", display: "Nicole", internal: "en-GB-Wavenet-N"},
  { vendor : "google", lang: "en-GB", gender: "m", display: "Owen", internal: "en-GB-Wavenet-O"},

  { vendor : "google", lang: "fr-CA", gender: "f", display: "Amelie", internal: "fr-CA-Wavenet-A"},
  { vendor : "google", lang: "fr-CA", gender: "m", display: "Beau", internal: "fr-CA-Wavenet-B"},
  { vendor : "google", lang: "fr-CA", gender: "f", display: "Cécile", internal: "fr-CA-Wavenet-C"},
  { vendor : "google", lang: "fr-CA", gender: "m", display: "Dion", internal: "fr-CA-Wavenet-D"},

  { vendor : "google", lang: "fr-FR", gender: "f", display: "Fran", internal: "fr-FR-Wavenet-F"},
  { vendor : "google", lang: "fr-FR", gender: "m", display: "Gaston", internal: "fr-FR-Wavenet-G"},

  { vendor : "google", lang: "de-DE", gender: "f", display: "Giselle", internal: "de-DE-Wavenet-G"},
  { vendor : "google", lang: "de-DE", gender: "m", display: "Hans", internal: "de-DE-Wavenet-H"},

  { vendor : "google", lang: "it-IT", gender: "f", display: "Edna", internal: "it-IT-Wavenet-E"},
  { vendor : "google", lang: "it-IT", gender: "m", display: "Francesco", internal: "it-IT-Wavenet-F"},

  { vendor : "google", lang: "pt-BR", gender: "f", display: "Adriana", internal: "pt-BR-Wavenet-A"},
  { vendor : "google", lang: "pt-BR", gender: "m", display: "Beto", internal: "pt-BR-Wavenet-B"},
  { vendor : "google", lang: "pt-BR", gender: "f", display: "Carla", internal: "pt-BR-Wavenet-C"},
  { vendor : "google", lang: "pt-BR", gender: "f", display: "Daniela", internal: "pt-BR-Wavenet-D"},
  { vendor : "google", lang: "pt-BR", gender: "m", display: "Edurardo", internal: "pt-BR-Wavenet-E"},

  { vendor : "google", lang: "pt-PT", gender: "f", display: "Elena", internal: "pt-PT-Wavenet-E"},
  { vendor : "google", lang: "pt-PT", gender: "m", display: "Felipe", internal: "pt-PT-Wavenet-F"},

  { vendor : "google", lang: "es-ES", gender: "m", display: "Edmundo", internal: "es-ES-Wavenet-E"},
  { vendor : "google", lang: "es-ES", gender: "f", display: "Flora", internal: "es-ES-Wavenet-F"},
  { vendor : "google", lang: "es-ES", gender: "m", display: "Gaspar", internal: "es-ES-Wavenet-G"},
  { vendor : "google", lang: "es-ES", gender: "f", display: "Heloisa", internal: "es-ES-Wavenet-H"},

  { vendor : "google", lang: "es-US", gender: "f", display: "Alma", internal: "es-US-Wavenet-A"},
  { vendor : "google", lang: "es-US", gender: "m", display: "Bernardo", internal: "es-US-Wavenet-B"},
  { vendor : "google", lang: "es-US", gender: "m", display: "Carlos", internal: "es-US-Wavenet-C"},

  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Heart", internal: "heart"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Bella", internal: "bella"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Michael", internal: "michael"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Alloy", internal: "alloy"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Aoede", internal: "aoede"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Kore", internal: "kore"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Jessica", internal: "jessica"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Nicole", internal: "nicole"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Nova", internal: "nova"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "River", internal: "river"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Sarah", internal: "sarah"},
  { vendor : "lemonfox", lang: "en-us", gender: "f", display: "Sky", internal: "sky"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Echo", internal: "echo"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Eric", internal: "eric"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Fenrir", internal: "fenrir"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Liam", internal: "liam"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Onyx", internal: "onyx"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Puck", internal: "puck"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Adam", internal: "adam"},
  { vendor : "lemonfox", lang: "en-us", gender: "m", display: "Santa", internal: "santa"},

  { vendor : "lemonfox", lang: "en-gb", gender: "f", display: "Alice", internal: "alice"},
  { vendor : "lemonfox", lang: "en-gb", gender: "f", display: "Emma", internal: "emma"},
  { vendor : "lemonfox", lang: "en-gb", gender: "f", display: "Isabella", internal: "isabella"},
  { vendor : "lemonfox", lang: "en-gb", gender: "f", display: "Lily", internal: "lily"},
  { vendor : "lemonfox", lang: "en-gb", gender: "m", display: "Daniel", internal: "daniel"},
  { vendor : "lemonfox", lang: "en-gb", gender: "m", display: "Fable", internal: "fable"},
  { vendor : "lemonfox", lang: "en-gb", gender: "m", display: "George", internal: "george"},
  { vendor : "lemonfox", lang: "en-gb", gender: "m", display: "Lewis", internal: "lewis"},


  { vendor : "lemonfox", lang: "es", gender: "f", display: "Dora", internal: "dora"},
  { vendor : "lemonfox", lang: "es", gender: "m", display: "Alex", internal: "alex"},
  { vendor : "lemonfox", lang: "es", gender: "m", display: "Noel", internal: "noel"},

  { vendor : "lemonfox", lang: "fr", gender: "f", display: "Siwis", internal: "siwis"},

  { vendor : "lemonfox", lang: "it", gender: "f", display: "Sara", internal: "sara"},
  { vendor : "lemonfox", lang: "it", gender: "m", display: "Nicola", internal: "nicola"},

  { vendor : "lemonfox", lang: "pt-br", gender: "f", display: "Clara", internal: "clara"},
  { vendor : "lemonfox", lang: "pt-br", gender: "m", display: "Tiago", internal: "tiago"},
  { vendor : "lemonfox", lang: "pt-br", gender: "m", display: "Papai", internal: "papai"},

]

function buildDisplayName(oneVoice) {
  const female = translateEnglishWords("female")
  const male = translateEnglishWords("male")

  const gender = (oneVoice.gender == "f") ? female : male
  const displayName = oneVoice.vendor + ": " + oneVoice.lang + " " + oneVoice.display + " (" +
                      gender + ")"
  return (displayName)
}

export function findMp3Entry(vendor,lang,name) {
  console.log("FIND MP3 ENTRY",vendor,lang,name)
  for (var i=0; i < mp3Voices.length; i++) {
    var oneVoice = mp3Voices[i]
    if (oneVoice.lang == lang && oneVoice.vendor == vendor && oneVoice.internal == name) {
      oneVoice.displayName = buildDisplayName(oneVoice)
      return (oneVoice)
    }
  }
  return (null)
}

export function getMp3Voices(languageInUse) {
  var voices = []

  var index = 0
  for (var i=0; i < mp3Voices.length; i++) {
    if (!mp3Voices[i].lang.startsWith(languageInUse))
        continue
      const oneMp3 = mp3Voices[i]
      const oneVoice = { index : index, lang:oneMp3.lang, name : oneMp3.internal, vendor : oneMp3.vendor,
                     displayName : buildDisplayName(oneMp3) }

      voices.push(oneVoice)
      index++
  }
  return (voices)
}

export function verifyMp3NameLanguage(languageInUse) {

  const connectionStore = useConnectionStore()  

  // get initial mp3 voices
  var playerMp3Name = connectionStore.getPlayerMp3Name
  var playerMp3Lang = connectionStore.getPlayerMp3Lang
  var playerMp3Vendor = connectionStore.getPlayerMp3Vendor
  var opponentMp3Name = connectionStore.getOpponentMp3Name
  var opponentMp3Lang = connectionStore.getOpponentMp3Lang
  var opponentMp3Vendor = connectionStore.getOpponentMp3Vendor

  var playerExists = false
  var opponentExists = false

  // if mp3 language is right, see if the name exists
  if (playerMp3Lang.startsWith(languageInUse)) {
    for (var i=0; i < mp3Voices.length; i++) {
      if (!mp3Voices[i].lang.startsWith(languageInUse))
        continue
      if (mp3Voices[i].vendor != playerMp3Vendor)
        continue
      if (mp3Voices[i].internal == playerMp3Name) {
        playerExists = true
        break
      }
    }
  }
  if (opponentMp3Lang.startsWith(languageInUse)) {
    for (var i=0; i < mp3Voices.length; i++) {
      if (!mp3Voices[i].lang.startsWith(languageInUse))
        continue
      if (mp3Voices[i].vendor != opponentMp3Vendor)
        continue
      if (mp3Voices[i].internal == opponentMp3Name) {
        opponentExists = true
        break
      }
    }
  }
  console.log("******************* language in use",languageInUse,playerExists,opponentExists)
  switch (languageInUse) {
    case "en" :
      if (!playerExists) {
        playerMp3Name = "en-US-Wavenet-C"
        playerMp3Lang = "en-US"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "en-US-Wavenet-D"
        opponentMp3Lang = "en-US"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
    case "es" :
      if (!playerExists) {
        playerMp3Name = "es-ES-Wavenet-F"
        playerMp3Lang = "es-ES"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "es-ES-Wavenet-E"
        opponentMp3Lang = "es-ES"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
    case "de" :
      if (!playerExists) {
        playerMp3Name = "de-DE-Wavenet-G"
        playerMp3Lang = "de-DE"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "de-DE-Wavenet-H"
        opponentMp3Lang = "de-DE"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
    case "it" :
      if (!playerExists) {
        playerMp3Name = "it-IT-Wavenet-E"
        playerMp3Lang = "it-IT"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "it-IT-Wavenet-F"
        opponentMp3Lang = "it-IT"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
    case "pt" :
      if (!playerExists) {
        playerMp3Name = "pt-PT-Wavenet-E"
        playerMp3Lang = "pt-PT"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "pt-PT-Wavenet-F"
        opponentMp3Lang = "pt-PT"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
    case "fr" :
      if (!playerExists) {
        playerMp3Name = "fr-FR-Wavenet-F"
        playerMp3Lang = "fr-FR"
        connectionStore.setPlayerMp3(playerMp3Name,playerMp3Lang,"google")
      }
      if (!opponentExists) {
        opponentMp3Name = "fr-FR-Wavenet-G"
        opponentMp3Lang = "fr-FR"
        connectionStore.setOpponentMp3(opponentMp3Name,opponentMp3Lang,"google")
      }
      break
  }
}
